var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kfContainer",staticClass:"kf-container"},[_c('div',{staticClass:"kf telegram flex flex-align-center flex-justify-center",attrs:{"data-aos":"zoom-in"},on:{"click":function($event){return _vm.openRandomLink(1)}}},[_c('img',{attrs:{"src":require("@/assets/image/Slice 32@3x(3).png")}}),_vm._v(_vm._s(_vm.$t('kf.telegram'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }